<template>
  <div>
    <FiltersForm
      :has-filters="hasFilters"
      :is-skeleton-loading="isSkeletonLoading"
      :is-global-country-filter="false"
      @filter="onFilter"
      @clear="onClearFilters"
    >
      <v-text-field
        clearable
        v-model="search"
        type="search"
        :label="$t('search')"
        prepend-inner-icon="search"
      />

      <base-date-picker
        :date="dates"
        placeholder="Dates"
        :config="dateConfig"
        :on-change="onChangeDate"
      />

      <v-autocomplete
        clearable
        v-model="status"
        :items="filterStatuses"
        prepend-inner-icon="download_done"
        item-title="name"
        item-value="id"
        :label="$t('status')"
      />

      <v-autocomplete
        clearable
        v-model="role"
        :items="filterRoles"
        prepend-inner-icon="download_done"
        item-title="name"
        item-value="code"
        :label="$t('role')"
      />
    </FiltersForm>
  </div>
</template>

<script>
  import FiltersForm from './FiltersBase';

  export default {
    components: {
      FiltersForm,
    },
    props: {
      isSkeletonLoading: {
        type: Boolean,
        default: false,
      }
    },
    emits: ['clearFilters', 'filter'],
    data() {
      return {
        dates: null,
        dateConfig: {
          mode: 'range',
        },
        search: null,
        status: null,
        role: null,
      };
    },
    computed: {
      filterStatuses() {
        return this.$store.getters['businessUsers/statuses'];
      },
      filterRoles() {
        return this.$store.getters['users/subRoles'];
      },
      hasFilters() {
        const {
          search,
          dates,
          role,
          status
        } = this;
        return !!search ||
          !!dates ||
          role !== null ||
          status !== null;
      },
    },
    methods: {
      onChangeDate(dates) {
        this.dates = dates;
      },
      onFilter() {
        const { search, dates, status, role } = this;

        this.$emit('filter', {
          search: search || null,
          date_filter: dates || null,
          status,
          role
        });
      },
      onClearFilters() {
        this.dates = null;
        this.search = null;
        this.status = null;
        this.role = null;

        this.$emit('clearFilters');
      },
    },
  };
</script>

<style lang="scss">

</style>
